(function () {
  var SCANNER_READY_KEY = "barcodeScannerReady";
  var SCANNER_BOUND_KEY = "__barcodeScannerBound";

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function withShopRoot(path) {
    var root = getShopRoot();

    if (!path) {
      return root;
    }

    if (path.indexOf("http://") === 0 || path.indexOf("https://") === 0) {
      return path;
    }

    return root.replace(/\/$/, "") + "/" + String(path).replace(/^\//, "");
  }

  function toAjaxCartAddUrl(root) {
    var raw = root.getAttribute("data-cart-add-url") || "/cart/add";

    if (raw.indexOf(".js") !== -1) {
      return withShopRoot(raw);
    }

    return withShopRoot(raw.replace(/\/$/, "") + ".js");
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "AUD"
      }).format(amount);
    } catch (error) {
      return "$" + amount.toFixed(2);
    }
  }

  function normalizeBarcode(value) {
    var raw = String(value || "").trim();

    if (!raw) {
      return "";
    }

    var numericMatches = raw.match(/\d{8,14}/g);

    if (numericMatches && numericMatches.length) {
      return numericMatches[numericMatches.length - 1].trim();
    }

    var shortNumericMatches = raw.match(/\d{6,7}/g);

    if (shortNumericMatches && shortNumericMatches.length) {
      return shortNumericMatches[shortNumericMatches.length - 1].trim();
    }

    return raw.replace(/\s+/g, "");
  }

  function uniqueBy(items, keyFn) {
    var seen = {};
    var out = [];

    items.forEach(function (item) {
      var key = keyFn(item);

      if (!key || seen[key]) {
        return;
      }

      seen[key] = true;
      out.push(item);
    });

    return out;
  }

  function displayValue(value) {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    if (Array.isArray(value)) {
      return value.map(displayValue).filter(Boolean).join(", ");
    }

    if (typeof value === "object") {
      return (
        value.name ||
        value.title ||
        value.label ||
        value.value ||
        value.display_name ||
        value.handle ||
        ""
      );
    }

    return String(value).trim();
  }

  function hasDisplayValue(value) {
    return displayValue(value) !== "";
  }

  function extractHandleFromUrl(url) {
    if (!url) {
      return "";
    }

    var clean = String(url).split("?")[0].replace(/\/$/, "");
    var parts = clean.split("/");
    var productsIndex = parts.indexOf("products");

    if (productsIndex >= 0 && parts[productsIndex + 1]) {
      return parts[productsIndex + 1];
    }

    return parts[parts.length - 1] || "";
  }

  function productUrlFromHandle(handle) {
    return withShopRoot("products/" + encodeURIComponent(handle));
  }

  function productJsonUrlFromHandle(handle) {
    return withShopRoot("products/" + encodeURIComponent(handle) + ".js");
  }

  function productScannerJsonUrlFromHandle(handle) {
  return (
    withShopRoot("products/" + encodeURIComponent(handle)) +
    "?view=barcode-scanner&_barcode_scanner=" +
    Date.now()
  );
  }

  function variantOptions(variant) {
    if (!variant) {
      return [];
    }

    if (Array.isArray(variant.options)) {
      return variant.options.map(function (value) {
        return String(value || "");
      });
    }

    return [variant.option1, variant.option2, variant.option3]
      .filter(function (value) {
        return value !== null && value !== undefined && value !== "";
      })
      .map(function (value) {
        return String(value || "");
      });
  }

  function variantTitle(variant) {
    if (!variant) {
      return "";
    }

    var title = variant.title || "";

    if (!title || title === "Default Title") {
      return "";
    }

    return title;
  }

  function productImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (product && product.featured_image) {
      return product.featured_image;
    }

    if (product && Array.isArray(product.images) && product.images.length) {
      return product.images[0];
    }

    return "";
  }

  function getProductOptions(product) {
    if (!product || !Array.isArray(product.options)) {
      return [];
    }

    return product.options.map(function (option, index) {
      if (typeof option === "string") {
        return {
          name: option,
          position: index + 1,
          values: uniqueBy(
            (product.variants || []).map(function (variant) {
              return variantOptions(variant)[index];
            }).filter(Boolean),
            function (value) {
              return value;
            }
          )
        };
      }

      return {
        name: option.name || ("Option " + (index + 1)),
        position: option.position || index + 1,
        values: option.values || uniqueBy(
          (product.variants || []).map(function (variant) {
            return variantOptions(variant)[index];
          }).filter(Boolean),
          function (value) {
            return value;
          }
        )
      };
    });
  }

  function findVariantFromSelections(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    return product.variants.find(function (variant) {
      var opts = variantOptions(variant);

      return selectedOptions.every(function (value, index) {
        return String(opts[index] || "") === String(value || "");
      });
    }) || null;
  }

  function productLooksLikeTcg(product) {
    var tcg = product && product.tcg ? product.tcg : {};
    var tags = Array.isArray(product && product.tags) ? product.tags.join(" ").toLowerCase() : "";
    var type = String((product && product.type) || "").toLowerCase();

    var hasTcgMetafields = Object.keys(tcg).some(function (key) {
      return hasDisplayValue(tcg[key]);
    });

    return (
      hasTcgMetafields ||
      type.indexOf("tcg") !== -1 ||
      type.indexOf("trading card") !== -1 ||
      tags.indexOf("tcg") !== -1 ||
      tags.indexOf("trading card") !== -1
    );
  }

  function tcgSubtitle(product, variant) {
    var tcg = product && product.tcg ? product.tcg : {};
    var parts = [];

    if (hasDisplayValue(tcg.set_name_expanded)) {
      parts.push(displayValue(tcg.set_name_expanded));
    }

    if (hasDisplayValue(tcg.card_number)) {
      parts.push("#" + displayValue(tcg.card_number));
    }

    if (hasDisplayValue(tcg.product_language)) {
      parts.push(displayValue(tcg.product_language));
    }

    if (hasDisplayValue(tcg.foil_treatment)) {
      parts.push(displayValue(tcg.foil_treatment));
    }

    if (!parts.length && variantTitle(variant)) {
      parts.push(variantTitle(variant));
    }

    return parts.join(" · ");
  }

  function setupBarcodeScanner(root) {
    if (!root) {
      return;
    }

    if (root[SCANNER_BOUND_KEY] === true) {
      return;
    }

    root[SCANNER_BOUND_KEY] = true;
    root.dataset[SCANNER_READY_KEY] = "true";

    var modal = root.querySelector("[data-barcode-scanner-modal]");
    var openBtn = root.querySelector("[data-barcode-scanner-open]");
    var closeBtns = Array.prototype.slice.call(root.querySelectorAll("[data-barcode-scanner-close]"));
    var manualForm = root.querySelector("[data-barcode-manual-form]");
    var barcodeInput = root.querySelector("[data-barcode-input]");
    var message = root.querySelector("[data-barcode-message]");
    var video = root.querySelector("[data-barcode-video]");
    var cameraPlaceholder = root.querySelector("[data-barcode-camera-placeholder]");
    var states = Array.prototype.slice.call(root.querySelectorAll("[data-barcode-state]"));

    var productState = root.querySelector('[data-barcode-state="product"]');
    var productMedia = root.querySelector("[data-barcode-product-media]");
    var productImagePlaceholder = root.querySelector("[data-barcode-product-image-placeholder]");
    var productVendor = root.querySelector("[data-barcode-product-vendor]");
    var productTitle = root.querySelector("[data-barcode-product-title]");
    var productVariant = root.querySelector("[data-barcode-product-variant]");
    var productPrice = root.querySelector("[data-barcode-product-price]");
    var productOptions = root.querySelector("[data-barcode-product-options]");
    var productStock = root.querySelector("[data-barcode-product-stock]");
    var quantityInput = root.querySelector("[data-barcode-quantity]");
    var addToCartBtn = root.querySelector("[data-barcode-add-to-cart]");
    var viewProductLink = root.querySelector("[data-barcode-view-product]");
    var searchLink = root.querySelector("[data-barcode-search-link]");
    var multipleSearchLink = root.querySelector("[data-barcode-multiple-search-link]");
    var scannedDebugEls = Array.prototype.slice.call(root.querySelectorAll("[data-barcode-scanned-debug]"));
    var scanAnotherBtns = Array.prototype.slice.call(root.querySelectorAll("[data-barcode-scan-another]"));

    var stream = null;
    var detector = null;
    var zxingReader = null;
    var zxingControls = null;
    var detecting = false;
    var selectedProduct = null;
    var selectedVariant = null;
    var lastBarcode = "";
    var zxingWaitAttempts = 0;
    var tcgPanel = null;

    function setMessage(text) {
      if (message) {
        message.textContent = text || "";
      }
    }

    function setScannedDebug(barcode, rawBarcode) {
      scannedDebugEls.forEach(function (el) {
        if (!el) {
          return;
        }

        var text = "Scanned barcode: " + (barcode || "unknown");

        if (rawBarcode && String(rawBarcode) !== String(barcode)) {
          text += " | Raw scan: " + String(rawBarcode);
        }

        el.textContent = text;
        el.hidden = false;
      });
    }

    function clearScannedDebug() {
      scannedDebugEls.forEach(function (el) {
        if (!el) {
          return;
        }

        el.textContent = "";
        el.hidden = true;
      });
    }

    function showCameraPlaceholder() {
      if (cameraPlaceholder) {
        cameraPlaceholder.hidden = false;
        cameraPlaceholder.style.display = "";
      }
    }

    function hideCameraPlaceholder() {
      if (cameraPlaceholder) {
        cameraPlaceholder.hidden = true;
        cameraPlaceholder.style.display = "none";
      }
    }

    function showState(name) {
      states.forEach(function (state) {
        state.hidden = state.getAttribute("data-barcode-state") !== name;
      });
    }

    function setBusy(isBusy) {
      if (manualForm) {
        manualForm.classList.toggle("is-busy", !!isBusy);
      }

      if (addToCartBtn) {
        addToCartBtn.classList.toggle("is-busy", !!isBusy);
      }
    }

    function clearTcgPanel() {
      if (tcgPanel) {
        tcgPanel.remove();
        tcgPanel = null;
      }

      if (productState) {
        productState.classList.remove("is-tcg-product");
      }
    }

    function addTcgRow(list, label, value) {
      var clean = displayValue(value);

      if (!clean) {
        return;
      }

      var row = document.createElement("div");
      row.className = "barcode-tcg-field";

      var dt = document.createElement("dt");
      dt.textContent = label;

      var dd = document.createElement("dd");
      dd.textContent = clean;

      row.appendChild(dt);
      row.appendChild(dd);
      list.appendChild(row);
    }

    function renderTcgPanel(product) {
      clearTcgPanel();

      if (!productLooksLikeTcg(product)) {
        return;
      }

      if (productState) {
        productState.classList.add("is-tcg-product");
      }

      var tcg = product && product.tcg ? product.tcg : {};

      tcgPanel = document.createElement("section");
      tcgPanel.className = "barcode-tcg-panel";
      tcgPanel.setAttribute("aria-label", "Trading card details");

      var heading = document.createElement("h4");
      heading.className = "barcode-tcg-panel__heading";
      heading.textContent = "Card details";
      tcgPanel.appendChild(heading);

      if (hasDisplayValue(tcg.card_description)) {
        var rules = document.createElement("div");
        rules.className = "barcode-tcg-rules";
        rules.textContent = displayValue(tcg.card_description);
        tcgPanel.appendChild(rules);
      }

      if (hasDisplayValue(tcg.tcg_flavor_text)) {
        var flavor = document.createElement("p");
        flavor.className = "barcode-tcg-flavor";
        flavor.textContent = displayValue(tcg.tcg_flavor_text);
        tcgPanel.appendChild(flavor);
      }

      var list = document.createElement("dl");
      list.className = "barcode-tcg-fields";

      addTcgRow(list, "Game", tcg.franchise);
      addTcgRow(list, "Set", tcg.set_name_expanded);
      addTcgRow(list, "Set code", tcg.set_code);
      addTcgRow(list, "Card number", tcg.card_number);
      addTcgRow(list, "Language", tcg.product_language);
      addTcgRow(list, "Treatment", tcg.foil_treatment);
      addTcgRow(list, "Stamp / promo", tcg.stamp_or_promo);
      addTcgRow(list, "Series", tcg.tcg_set_series);
      addTcgRow(list, "Type", tcg.card_type);
      addTcgRow(list, "Colour", tcg.card_colour);
      addTcgRow(list, "Play cost", tcg.card_play_cost);
      addTcgRow(list, "Illustrator", tcg.card_illustrator);
      addTcgRow(list, "Main character", tcg.main_character);
      addTcgRow(list, "Release date", tcg.initial_release_date);
      addTcgRow(list, "Edition", tcg.edition_code);
      addTcgRow(list, "Condition", tcg.card_condition);
      addTcgRow(list, "TCGplayer ID", tcg.tcgplayer_id);

      if (list.children.length) {
        tcgPanel.appendChild(list);
      }

      if (productOptions && productOptions.parentNode) {
        productOptions.parentNode.insertBefore(tcgPanel, productOptions);
      }
    }

    function openModal() {
      if (!modal) {
        return;
      }

      modal.hidden = false;
      document.body.classList.add("barcode-scanner-is-open");
      showState("scanner");

      clearScannedDebug();
      clearTcgPanel();
      zxingWaitAttempts = 0;

      window.setTimeout(function () {
        if (barcodeInput) {
          barcodeInput.focus();
        }
      }, 50);

      startCamera();
    }

    function closeModal() {
      if (!modal) {
        return;
      }

      modal.hidden = true;
      document.body.classList.remove("barcode-scanner-is-open");
      stopCamera();
    }

    function stopCamera() {
      detecting = false;

      if (zxingControls && typeof zxingControls.stop === "function") {
        try {
          zxingControls.stop();
        } catch (error) {
          // Ignore scanner cleanup errors.
        }
      }

      zxingControls = null;

      if (zxingReader && typeof zxingReader.reset === "function") {
        try {
          zxingReader.reset();
        } catch (error) {
          // Ignore scanner cleanup errors.
        }
      }

      var activeStream = stream || (video && video.srcObject);

      if (activeStream && typeof activeStream.getTracks === "function") {
        activeStream.getTracks().forEach(function (track) {
          try {
            track.stop();
          } catch (error) {
            // Ignore track cleanup errors.
          }
        });
      }

      stream = null;

      if (video) {
        video.srcObject = null;
      }

      showCameraPlaceholder();
    }

    function startCamera() {
      if (!video || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setMessage("Camera access is not available in this browser. Please enter the barcode manually.");
        return;
      }

      if (window.ZXing && window.ZXing.BrowserMultiFormatReader) {
        startZxingCamera();
        return;
      }

      if (zxingWaitAttempts < 12) {
        zxingWaitAttempts += 1;
        setMessage("Loading barcode scanner...");
        window.setTimeout(startCamera, 180);
        return;
      }

      if ("BarcodeDetector" in window) {
        startNativeBarcodeDetectorCamera();
        return;
      }

      setMessage("Barcode detection did not load. Please enter the barcode manually.");
      showCameraPlaceholder();
    }

    function startZxingCamera() {
      try {
        if (zxingReader && typeof zxingReader.reset === "function") {
          zxingReader.reset();
        }

        zxingReader = new window.ZXing.BrowserMultiFormatReader();
        detecting = true;

        hideCameraPlaceholder();
        setMessage("Scanner ready. Point your camera at a barcode or QR code.");

        var result = zxingReader.decodeFromVideoDevice(null, video, function (scanResult) {
          if (!detecting || !scanResult) {
            return;
          }

          var rawText = "";

          if (typeof scanResult.getText === "function") {
            rawText = scanResult.getText();
          } else if (scanResult.text) {
            rawText = scanResult.text;
          } else if (scanResult.rawValue) {
            rawText = scanResult.rawValue;
          }

          var code = normalizeBarcode(rawText);

          if (!code || code === lastBarcode) {
            return;
          }

          lastBarcode = code;
          setMessage("Barcode found: " + code);
          setScannedDebug(code, rawText);
          stopCamera();
          handleBarcode(code);
        });

        if (result && typeof result.then === "function") {
          result
            .then(function (controls) {
              if (controls) {
                zxingControls = controls;
              }

              hideCameraPlaceholder();
              setMessage("Scanner ready. Point your camera at a barcode or QR code.");
            })
            .catch(function () {
              setMessage("Camera scanner could not start. Please enter the barcode manually.");
              showCameraPlaceholder();
            });
        } else if (result) {
          zxingControls = result;
        }
      } catch (error) {
        setMessage("Camera scanner could not start. Please enter the barcode manually.");
        showCameraPlaceholder();
      }
    }

    function startNativeBarcodeDetectorCamera() {
      window.BarcodeDetector.getSupportedFormats()
        .then(function (formats) {
          var preferredFormats = [
            "qr_code",
            "ean_13",
            "ean_8",
            "upc_a",
            "upc_e",
            "code_128",
            "code_39",
            "code_93",
            "itf"
          ].filter(function (format) {
            return formats.indexOf(format) !== -1;
          });

          detector = new window.BarcodeDetector({
            formats: preferredFormats.length ? preferredFormats : formats
          });

          return navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: {
                ideal: "environment"
              }
            },
            audio: false
          });
        })
        .then(function (mediaStream) {
          stream = mediaStream;
          video.srcObject = mediaStream;

          hideCameraPlaceholder();

          setMessage("Native scanner ready. Point your camera at a barcode or QR code.");
          detecting = true;
          detectLoop();
        })
        .catch(function () {
          setMessage("Camera could not be started. Please enter the barcode manually.");
          showCameraPlaceholder();
        });
    }

    function detectLoop() {
      if (!detecting || !detector || !video || modal.hidden) {
        return;
      }

      if (video.readyState >= 2) {
        detector.detect(video)
          .then(function (barcodes) {
            if (!detecting || !barcodes || !barcodes.length) {
              window.requestAnimationFrame(detectLoop);
              return;
            }

            var rawText = barcodes[0].rawValue;
            var code = normalizeBarcode(rawText);

            if (!code || code === lastBarcode) {
              window.requestAnimationFrame(detectLoop);
              return;
            }

            lastBarcode = code;
            setMessage("Barcode found: " + code);
            setScannedDebug(code, rawText);
            stopCamera();
            handleBarcode(code);
          })
          .catch(function () {
            window.requestAnimationFrame(detectLoop);
          });

        return;
      }

      window.requestAnimationFrame(detectLoop);
    }

    function searchUrlForBarcode(barcode) {
      var searchBase = root.getAttribute("data-search-url") || "/search";

      return (
        searchBase +
        "?q=" +
        encodeURIComponent(barcode) +
        "&type=product&options%5Bprefix%5D=last"
      );
    }

    function setSearchLinks(barcode) {
      var href = searchUrlForBarcode(barcode);

      if (searchLink) {
        searchLink.href = href;
      }

      if (multipleSearchLink) {
        multipleSearchLink.href = href;
      }
    }

    function isUsefulProduct(product) {
      return !!(
        product &&
        (
          product.title ||
          product.handle ||
          product.featured_image ||
          (Array.isArray(product.images) && product.images.length) ||
          (Array.isArray(product.variants) && product.variants.length)
        )
      );
    }

    function mergeProductData(coreProduct, scannerProduct, handle) {
      var core = coreProduct || {};
      var scanner = scannerProduct || {};
      var merged = {};

      Object.keys(core).forEach(function (key) {
        merged[key] = core[key];
      });

      Object.keys(scanner).forEach(function (key) {
        var value = scanner[key];

        if (key === "tcg") {
          return;
        }

        if (value === null || value === undefined || value === "") {
          return;
        }

        if (Array.isArray(value) && !value.length) {
          return;
        }

        merged[key] = value;
      });

      merged.title = core.title || scanner.title || "";
      merged.handle = core.handle || scanner.handle || handle || "";
      merged.url = core.url || scanner.url || productUrlFromHandle(merged.handle);
      merged.vendor = core.vendor || scanner.vendor || "";
      merged.type = core.type || scanner.type || "";
      merged.tags = Array.isArray(core.tags) && core.tags.length ? core.tags : scanner.tags || [];

      merged.available = core.available !== null && core.available !== undefined
        ? core.available
        : scanner.available;

      merged.featured_image = core.featured_image || scanner.featured_image || null;
      merged.images = Array.isArray(core.images) && core.images.length ? core.images : scanner.images || [];
      merged.options = Array.isArray(core.options) && core.options.length ? core.options : scanner.options || [];
      merged.variants = Array.isArray(core.variants) && core.variants.length ? core.variants : scanner.variants || [];
      merged.tcg = scanner.tcg || core.tcg || {};

      return merged;
    }

    function fetchProductJsByHandle(handle) {
      return fetch(productJsonUrlFromHandle(handle), {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Product JSON lookup failed");
        }

        return response.json();
      }).then(function (product) {
        product.handle = product.handle || handle;
        product.url = product.url || productUrlFromHandle(handle);
        return product;
      });
    }

    function fetchProductScannerJsonByHandle(handle) {
  return fetch(productScannerJsonUrlFromHandle(handle), {
    credentials: "same-origin",
    cache: "no-store",
    headers: {
      "Accept": "application/json, text/plain, */*"
    }
  }).then(function (response) {
    if (!response.ok) {
      throw new Error("Scanner product JSON lookup failed");
    }

    return response.text();
  }).then(function (text) {
    var product = JSON.parse(text.trim());

    product.handle = product.handle || handle;
    product.url = product.url || productUrlFromHandle(handle);

    return product;
  });
  }

    function fetchProductByHandle(handle) {
  return fetchProductJsByHandle(handle).then(function (coreProduct) {
    var scannerHandle = coreProduct.handle || handle;

    return fetchProductScannerJsonByHandle(scannerHandle)
      .then(function (scannerProduct) {
        return mergeProductData(coreProduct, scannerProduct, scannerHandle);
      })
      .catch(function () {
        return coreProduct;
      });
  });
  }

    function lookupByProxy(barcode) {
      var lookupUrl = root.getAttribute("data-barcode-lookup-url");

      if (!lookupUrl) {
        return Promise.resolve(null);
      }

      var separator = lookupUrl.indexOf("?") === -1 ? "?" : "&";
      var url = lookupUrl + separator + "barcode=" + encodeURIComponent(barcode);

      return fetch(url, {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Barcode lookup failed");
        }

        return response.json();
      }).then(function (data) {
        if (!data) {
          return {
            matches: []
          };
        }

        if (Array.isArray(data.matches)) {
          return data;
        }

        if (data.product) {
          return {
            matches: [
              {
                product: data.product,
                matched_variant_id: data.matched_variant_id || data.variant_id
              }
            ]
          };
        }

        return {
          matches: []
        };
      });
    }

    function variantLooksLikeBarcodeMatch(variant, barcode) {
      if (!variant) {
        return false;
      }

      var target = normalizeBarcode(barcode);

      var candidates = [
        variant.barcode,
        variant.sku,
        variant.id,
        variant.title,
        variant.name,
        variant.public_title
      ];

      return candidates.some(function (value) {
        if (value === null || value === undefined || value === "") {
          return false;
        }

        return normalizeBarcode(value) === target || String(value).trim() === String(barcode).trim();
      });
    }

    function guessVariantIdForProduct(product, barcode) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];

      if (!variants.length) {
        return null;
      }

      var exact = variants.find(function (variant) {
        return variantLooksLikeBarcodeMatch(variant, barcode);
      });

      if (exact) {
        return exact.id;
      }

      if (variants.length === 1) {
        return variants[0].id;
      }

      var available = variants.find(function (variant) {
        return variant.available;
      });

      return available ? available.id : variants[0].id;
    }

    function matchesFromProducts(products, barcode, allowFallback) {
      var exactMatches = [];
      var fallbackMatches = [];

      products.forEach(function (product) {
        var variants = Array.isArray(product.variants) ? product.variants : [];

        variants.forEach(function (variant) {
          if (variantLooksLikeBarcodeMatch(variant, barcode)) {
            exactMatches.push({
              product: product,
              matched_variant_id: variant.id
            });
          }
        });

        fallbackMatches.push({
          product: product,
          matched_variant_id: guessVariantIdForProduct(product, barcode)
        });
      });

      if (exactMatches.length) {
        return exactMatches;
      }

      if (allowFallback) {
        return fallbackMatches;
      }

      return [];
    }

    function fetchProductsByHandles(handles) {
      return Promise.all(handles.map(fetchProductByHandle));
    }

    function handlesFromSearchHtml(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");

      var links = Array.prototype.slice.call(
        doc.querySelectorAll('a[href*="/products/"]')
      );

      var handles = links
        .map(function (link) {
          return extractHandleFromUrl(link.getAttribute("href") || "");
        })
        .filter(Boolean);

      return uniqueBy(handles, function (handle) {
        return handle;
      });
    }

    function lookupBySearchPage(barcode) {
      return fetch(searchUrlForBarcode(barcode), {
        credentials: "same-origin",
        headers: {
          "Accept": "text/html"
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Search page lookup failed");
          }

          return response.text();
        })
        .then(function (html) {
          var handles = handlesFromSearchHtml(html);

          if (!handles.length) {
            return {
              matches: []
            };
          }

          handles = handles.slice(0, 1);

          return fetchProductsByHandles(handles).then(function (products) {
            return {
              matches: matchesFromProducts(products, barcode, true)
            };
          });
        });
    }

    function lookupByThemeSearch(barcode) {
      var suggestUrl =
        withShopRoot("search/suggest.json") +
        "?q=" +
        encodeURIComponent(barcode) +
        "&resources[type]=product" +
        "&resources[limit]=10";

      return fetch(suggestUrl, {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Search lookup failed");
          }

          return response.json();
        })
        .then(function (data) {
          var products =
            data &&
            data.resources &&
            data.resources.results &&
            Array.isArray(data.resources.results.products)
              ? data.resources.results.products
              : [];

          var handles = uniqueBy(
            products
              .map(function (product) {
                return extractHandleFromUrl(product.url || product.handle || "");
              })
              .filter(Boolean),
            function (handle) {
              return handle;
            }
          );

          if (!handles.length) {
            return {
              matches: []
            };
          }

          handles = handles.slice(0, 1);

          return fetchProductsByHandles(handles).then(function (hydratedProducts) {
            return {
              matches: matchesFromProducts(hydratedProducts, barcode, true)
            };
          });
        })
        .then(function (suggestResult) {
          if (suggestResult && suggestResult.matches && suggestResult.matches.length) {
            return suggestResult;
          }

          return lookupBySearchPage(barcode);
        })
        .catch(function () {
          return lookupBySearchPage(barcode);
        });
    }

    function lookupBarcode(barcode) {
      return lookupByProxy(barcode).then(function (proxyResult) {
        if (proxyResult) {
          return proxyResult;
        }

        return lookupByThemeSearch(barcode);
      });
    }

    function hydrateProductFromMatch(match) {
      if (!match || !match.product) {
        return Promise.resolve(null);
      }

      var product = match.product;
      var matchedVariantId = match.matched_variant_id || match.variant_id;

      if (product.handle) {
        return fetchProductByHandle(product.handle).then(function (hydratedProduct) {
          return {
            product: hydratedProduct,
            matched_variant_id: matchedVariantId
          };
        });
      }

      if (product.variants && product.variants.length) {
        return Promise.resolve({
          product: product,
          matched_variant_id: matchedVariantId
        });
      }

      return Promise.resolve({
        product: product,
        matched_variant_id: matchedVariantId
      });
    }

    function renderProductImage(product, variant) {
      if (!productMedia) {
        return;
      }

      var oldImage = productMedia.querySelector("[data-barcode-product-image]");
      var imageUrl = productImage(product, variant);

      if (oldImage) {
        oldImage.remove();
      }

      if (!imageUrl) {
        if (productImagePlaceholder) {
          productImagePlaceholder.hidden = false;
        }
        return;
      }

      if (productImagePlaceholder) {
        productImagePlaceholder.hidden = true;
      }

      var img = document.createElement("img");
      img.setAttribute("data-barcode-product-image", "");
      img.src = imageUrl;
      img.alt = product.title || "";
      img.loading = "lazy";
      img.width = 600;
      img.height = 600;

      productMedia.insertBefore(img, productMedia.firstChild);
    }

    function renderOptions(product, variant) {
      if (!productOptions) {
        return;
      }

      var options = getProductOptions(product);

      productOptions.innerHTML = "";

      if (!options.length || !product.variants || product.variants.length <= 1) {
        productOptions.hidden = true;
        return;
      }

      productOptions.hidden = false;

      var selectedOptions = variantOptions(variant);

      options.forEach(function (option, index) {
        var field = document.createElement("label");
        field.className = "barcode-product-option";

        var label = document.createElement("span");
        label.className = "barcode-product-option__label";
        label.textContent = option.name;

        var select = document.createElement("select");
        select.className = "barcode-product-option__select";
        select.setAttribute("data-barcode-option-index", String(index));

        option.values.forEach(function (value) {
          var opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;

          if (String(value) === String(selectedOptions[index] || "")) {
            opt.selected = true;
          }

          select.appendChild(opt);
        });

        field.appendChild(label);
        field.appendChild(select);
        productOptions.appendChild(field);
      });
    }

    function updateSelectedVariantFromOptions() {
      if (!selectedProduct || !productOptions) {
        return;
      }

      var selects = Array.prototype.slice.call(productOptions.querySelectorAll("select"));
      var selectedOptions = selects.map(function (select) {
        return select.value;
      });

      var nextVariant = findVariantFromSelections(selectedProduct, selectedOptions);

      if (nextVariant) {
        selectedVariant = nextVariant;
        updateProductDetails(selectedProduct, selectedVariant, false);
      }
    }

    function updateProductDetails(product, variant, rerenderOptions) {
      var isTcg = productLooksLikeTcg(product);

      selectedProduct = product;
      selectedVariant = variant;

      if (productVendor) {
        var tcg = product && product.tcg ? product.tcg : {};
        productVendor.textContent = isTcg && hasDisplayValue(tcg.franchise)
          ? displayValue(tcg.franchise)
          : product.vendor || "";
      }

      if (productTitle) {
        productTitle.textContent = product.title || "Product";
      }

      if (productVariant) {
        productVariant.textContent = isTcg
          ? tcgSubtitle(product, variant) || variantTitle(variant) || "Trading card"
          : variantTitle(variant) || "Selected product";
      }

      if (productPrice) {
        productPrice.textContent = formatMoney(variant && variant.price);
      }

      if (productStock) {
        productStock.textContent = variant && variant.available ? "In stock" : "Out of stock";
      }

      if (quantityInput) {
        quantityInput.value = "1";
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !(variant && variant.available);
        addToCartBtn.textContent = variant && variant.available ? "Add to cart" : "Out of stock";
      }

      if (viewProductLink) {
        viewProductLink.href = product.url || productUrlFromHandle(product.handle);
      }

      renderProductImage(product, variant);
      renderTcgPanel(product);

      if (rerenderOptions !== false) {
        renderOptions(product, variant);
      }
    }

    function showProduct(match) {
      hydrateProductFromMatch(match).then(function (hydrated) {
        if (!hydrated || !hydrated.product) {
          showState("none");
          return;
        }

        var product = hydrated.product;
        var matchedVariantId = hydrated.matched_variant_id;

        var variant = null;

        if (matchedVariantId && product.variants) {
          variant = product.variants.find(function (item) {
            return String(item.id) === String(matchedVariantId);
          }) || null;
        }

        if (!variant && product.variants && product.variants.length) {
          variant = product.variants[0];
        }

        updateProductDetails(product, variant, true);
        showState("product");
      }).catch(function () {
        showState("none");
      });
    }

    function handleBarcode(rawBarcode) {
      var barcode = normalizeBarcode(rawBarcode);

      if (!barcode) {
        setMessage("Please enter a barcode.");
        return;
      }

      lastBarcode = barcode;
      setSearchLinks(barcode);
      setScannedDebug(barcode, rawBarcode);
      setMessage("Scanned barcode: " + barcode);
      setBusy(true);
      showState("loading");

      lookupBarcode(barcode)
        .then(function (result) {
          var matches = result && Array.isArray(result.matches) ? result.matches : [];

          if (matches.length === 1) {
            showProduct(matches[0]);
            return;
          }

          if (matches.length > 1) {
            showState("multiple");
            return;
          }

          showState("none");
        })
        .catch(function () {
          showState("none");
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function resetScanner() {
      selectedProduct = null;
      selectedVariant = null;
      lastBarcode = "";
      zxingWaitAttempts = 0;

      if (barcodeInput) {
        barcodeInput.value = "";
      }

      clearScannedDebug();
      clearTcgPanel();
      setMessage("Scan a barcode or enter one manually.");
      showState("scanner");
      startCamera();

      window.setTimeout(function () {
        if (barcodeInput) {
          barcodeInput.focus();
        }
      }, 50);
    }

    function addSelectedToCart() {
      if (!selectedVariant || !selectedVariant.id || addToCartBtn.disabled) {
        return;
      }

      var qty = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Adding...";

      fetch(toAjaxCartAddUrl(root), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedVariant.id,
              quantity: qty
            }
          ]
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Add to cart failed");
        }

        return response.json();
      }).then(function () {
        addToCartBtn.textContent = "Added";
        document.dispatchEvent(new CustomEvent("barcode-scanner:cart-added", {
          bubbles: true,
          detail: {
            product: selectedProduct,
            variant: selectedVariant,
            quantity: qty
          }
        }));
      }).catch(function () {
        addToCartBtn.textContent = "Could not add";
      }).finally(function () {
        window.setTimeout(function () {
          if (selectedVariant && selectedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = "Add to cart";
          }
        }, 1200);
      });
    }

    if (openBtn) {
      openBtn.addEventListener("click", openModal);
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", closeModal);
    });

    if (manualForm) {
      manualForm.addEventListener("submit", function (event) {
        event.preventDefault();
        handleBarcode(barcodeInput && barcodeInput.value);
      });
    }

    if (productOptions) {
      productOptions.addEventListener("change", updateSelectedVariantFromOptions);
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", addSelectedToCart);
    }

    scanAnotherBtns.forEach(function (btn) {
      btn.addEventListener("click", resetScanner);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll("[data-barcode-scanner-root]");
    roots.forEach(setupBarcodeScanner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) {
      return;
    }

    var root = event.target.querySelector("[data-barcode-scanner-root]");

    if (root) {
      root[SCANNER_BOUND_KEY] = false;
      setupBarcodeScanner(root);
    }
  });
})();